// The destinations of the toolbar (APPLE-SPEC §5.3; 16 Oct 2026): ECONIC · Agents ⌄ · My workspace (the DT Administrator, who holds no
// content clearance, sees Trust Centre · Accounts · Audit log). Plain 13 / 500 text in --label-2 with no icon and no fill; hover turns it
// to the label colour; the active one (`aria-current="page"`) is the label colour at 600 with a 2 px navy indicator flush with the bar's
// bottom edge, its semibold width reserved so neighbours never shift; keyboard focus is a 2 px teal outline around the label. No item
// carries a dot or a count: the bell is the only place that says something waits. Agents opens its menu on click (aria-haspopup="menu"),
// ↓ or Enter; the 10 px chevron turns while it is open. WP-SHELL.
import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { Link, useLocation } from "react-router";
import { useTranslation } from "@ncp/i18n";
import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@ncp/ui";
import { useWorkspace } from "../../app/workspace-context";
import { destinationOf, visibleDestinations } from "./destinations";
import { AgentsMenuBody } from "./AgentsMenu";

function Inner({ label, chevron = false }: { label: string; chevron?: boolean }) {
  return (
    <span className="in">
      <span className="nl" data-l={label}>{label}</span>
      {chevron ? <ChevronDown className="chev" aria-hidden /> : null}
    </span>
  );
}

export function PrimaryNav() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { can } = useWorkspace();
  const active = destinationOf(pathname);
  const { items } = visibleDestinations(can);

  return (
    <nav className="es-nav" aria-label={t("assistant:econic.shell.nav.primary")} data-econic-nav="">
      {items.map((d) => {
        const current = active === d.id;
        const label = t(`assistant:econic.shell.nav.${d.label}`);
        if (d.id === "intelligence") return <AgentsItem key={d.id} label={label} current={current} can={can} />;
        return (
          <Link key={d.id} to={d.href} className="es-nav-item" aria-current={current ? "page" : undefined} data-destination={d.id}>
            <Inner label={label} />
          </Link>
        );
      })}
    </nav>
  );
}

function AgentsItem({ label, current, can }: { label: string; current: boolean; can: (p: string) => boolean }) {
  const [open, setOpen] = useState(false);
  return (
    <DropdownMenu open={open} onOpenChange={setOpen} modal={false}>
      <DropdownMenuTrigger asChild>
        <button type="button" className="es-nav-item" aria-current={current ? "page" : undefined} aria-haspopup="menu" data-destination="intelligence">
          <Inner label={label} chevron />
        </button>
      </DropdownMenuTrigger>
      {/* the menu's text column lines up with the label: 5 (padding) + 10 (row) + 12 (tick) + 8 (gap) = 35 px before the glyph */}
      <DropdownMenuContent align="start" alignOffset={-35} sideOffset={6} collisionPadding={8} className="es-pop menu min-w-0 overflow-visible p-[5px]" loop>
        <AgentsMenuBody onNavigate={() => setOpen(false)} can={can} />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
